import { StyleSheet } from 'react-native';

import { heightPercentageToDP, isTabletOrWeb } from 'utils/responsiveness';

import { ImageSize } from 'components/NagraImage/types';

const styles = StyleSheet.create({
    root: {
        alignSelf: isTabletOrWeb ? 'flex-start' : 'center',
        marginBottom: heightPercentageToDP(4),
        borderRadius: ImageSize.PROFILE_IMAGE.width,
        overflow: 'hidden',
    },
    container: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundColor: '#1D1D1D',
    },
});

export default styles;
